import styled, { css } from 'styled-components';

const FooterContainer = styled.footer`
  width: 100%;

  ${({ theme }) => css`
    padding: ${theme.spacing(1)};
    background-color: ${theme.colors.neutral.chromatic[100]};
    border-radius: 0 0 ${theme.spacing(2)} ${theme.spacing(2)};
  `}
`;

export { FooterContainer };
